import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col
} from 'reactstrap';

const AccommodationVoucher = () => {
  const { beneficiaryId } = useParams();

  return (
    <Container fluid>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <h4 className="mb-0">
                <i className="fas fa-home me-2"></i>
                Generate Accommodation Voucher
              </h4>
            </CardHeader>
            <CardBody>
              <div className="text-center py-5">
                <i className="fas fa-home fa-4x text-muted mb-3"></i>
                <h5>Accommodation Voucher Generation</h5>
                <p className="text-muted">
                  Generate accommodation voucher for beneficiary ID: {beneficiaryId}
                </p>
                <p className="text-muted small">
                  This page will handle the generation of accommodation-specific vouchers.
                </p>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AccommodationVoucher;